module.exports = __webpack_public_path__ + "static/media/empty_drafts.da05101d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/empty_drafts.png
// module id = 787
// module chunks = 0